import { wrapLetters, unwrapLetters } from './helpers.js';

class Slider {
    constructor(el) {
        this.el = el;
        this.elHeight = el.getBoundingClientRect().height;
        this.Y = 0;
        this.currentEl = document.querySelector('.hero:nth-child(1)');
        // this.vh = window.innerHeight;
        this.vh = document.querySelector('.roll').clientHeight;
        this.margin = el.children[1].offsetTop - el.children[0].offsetTop;
    }

    push(by, tween) {
        this.scrollTo(this.Y + by, tween);
    }

    scrollTo(val, tween = true) {
        let time = C.sliderTransitionTime / 1000;
        if (!tween) {
            time = 0;
        }
        TweenMax.to(this.el, time, {
            css: {
                transform: 'translateY('+ val +'px)',
            },
            ease: Quad.easeInOut,
        });

        this.Y = val;
    }

    goToTop() {
        this.scrollTo(-this.elHeight - 100, false);
    }

    next() {
        if (this.currentEl) { this.currentEl.classList.remove('current'); }
        let nextEl = this.currentEl.previousElementSibling;
        if ( !nextEl ) {
            this.goToTop();
            nextEl = this.el.querySelector(`.hero:last-child`);
        }
        this.currentEl = nextEl;

        nextEl.classList.add('current');
        this.scrollTo((-nextEl.offsetTop + (this.vh / 2)) - (this.margin/2));



    }
}

export default Slider;



// WEBPACK FOOTER //
// ./roll_of_honor/javascript/slider.js